import Dashboard from 'components/dashboard';
import ManageDealers from 'components/manageDealers';
import NewPlan from 'components/auto-lob/newPlan';
import Payment from 'components/auto-lob/payment';
import Transactions from 'components/transactions';
import ErrorPage from 'widgets/errorScreen';
import Thankyou from 'components/thankyou';
import ContactUs from 'components/contactUs';
import DealerForm from 'components/auto-lob/dealerForm';
import { useEffect } from 'react';
import { LOB } from 'utils/constants';
import ReportDashboard from 'components/reportDashboard';
import DealerDetails from 'components/dealerDetails';
import Details from 'components/details';
import WalletTransactions from 'components/walletTransactions';
import PaymentMode from 'components/paymentMode';
import LegalDocumentsUpload from 'components/legalDocuments';
import GSTDetails from 'components/gstDetails';
import ServiceCenterOnboarding from 'components/serviceCenterOnboarding';

function getRoutePathAther(route) {
    useEffect(() => {
        window.lob = LOB.AUTO;
    }, []);
    switch (route) {
        case 'dashboard':
            return <Dashboard />;
        case 'form':
            return <DealerForm />;
        case 'manage-dealers':
            return <ManageDealers />;
        case 'new-plan':
            return <NewPlan />;
        case 'payment':
            return <Payment />;
        case 'transactions':
            return <Transactions />;
        case 'thankyou':
            return <Thankyou />;
        case 'contact-us':
            return <ContactUs />;
        case 'report-dashboard':
            return <ReportDashboard />;
        case 'dealer-details':
            return <DealerDetails />;
        case 'legal-documents':
            return <LegalDocumentsUpload />;
        case 'gst-details':
            return <GSTDetails />;
        case 'details':
            return <Details />;
        case 'wallet-transactions':
            return <WalletTransactions />;
        case 'payment-mode':
            return <PaymentMode />;
        case 'service-partner':
            return <ServiceCenterOnboarding />;
        default:
            return <ErrorPage />;
    }
}

export default getRoutePathAther;
